import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form, Select } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";
import CrudButtons from "components/button/crudbuttons";
import { Send } from "lucide-react";
import {
    getTicketDetails,
    doTicketCreate,
} from "../../../../../redux/supportticket/supportticketState";

export const DEPT_IT = 16;
export const DEPT_HR = 15;
export const DEPT_PS = 171;

const SupportTicket = ({
    onCancel,
    getRecord,
    recordData, 
    requesting, 
    success,
    doCreate, 
    doUpdate, 
    variant = 'it-support',
    ...props
}) => {
    const { recordId, mode } = props;
    const [form] = Form.useForm();

    // Configuration based on variant
    const config = {
        'it-support': {
            deptId: DEPT_IT,
            prefix: 'IT',
            titlesField: 'ITtitles',
            categoryField: 'ITcategory',
            priorityField: 'priority',
            submitButtonClass: 'blue',
            placeholder: "Brief description of the issue"
        },
        'hr-support': {
            deptId: DEPT_HR,
            prefix: 'PC',
            titlesField: 'HRtitles',
            categoryField: 'HRcategory',
            priorityField: 'priority',
            submitButtonClass: 'rose',
            placeholder: "Brief description of your request"
        },
        'partner-service': {
            deptId: DEPT_PS,
            prefix: 'PS',
            titlesField: 'PStitles',
            categoryField: 'PScategory',
            priorityField: 'priority',
            submitButtonClass: 'purple',
            placeholder: "Brief description of your inquiry",
        }
    };

    const currentConfig = config[variant] || config['it-support'];

    useEffect(() => {
        getRecord(recordId);
    }, [getRecord, recordId]);

    const onSubmit = (formData) => {
        try {
            formData.prefix = currentConfig.prefix;
            formData.tic_department_id = currentConfig.deptId;

            recordData?.tic_id > 0 ? doUpdate(formData) : doCreate(formData); 
        } catch (error) {
            console.error('Save failed:', error);
        }
    };

    const categoryOptions = recordData?.[currentConfig.categoryField] || [];
    const priorityOptions = recordData?.[currentConfig.priorityField] || [];
    const titleOptions = recordData?.[currentConfig.titlesField] || [];

    return (
        <Card className="p-0">
            <Form
                form={form}
                className={mode !== "view" ? "form" : ""}
                layout="vertical" 
                onFinish={onSubmit}
            >
                <div>
                    <div className="space-y-2">
                        <FormItem
                            name="tic_title_id" 
                            label="Issue Title"
                            rules={[requiredField()]}
                        >
                            <Select 
                                id="tic_title_id"
                                allowClear={true}
                                className="input-field"
                                options={titleOptions}
                                placeholder={currentConfig.placeholder}
                            />
                        </FormItem>
                        <FormItem
                            name="tic_category_id" 
                            label="Category"
                            rules={[requiredField()]}
                        >
                            <Select 
                                id="tic_category_id"
                                allowClear={true}
                                className="input-field"
                                options={categoryOptions}
                                placeholder="Select category"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_priority_id" 
                            label="Priority"
                            rules={[requiredField()]}
                        >
                            <Select 
                                id="tic_priority_id"
                                allowClear={true}
                                className="input-field"
                                options={priorityOptions}
                                placeholder="Select priority"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_description"
                            label="Details"
                            rules={[requiredField()]}
                        >
                            <TextArea
                                id="tic_description" 
                                className="input-field"
                                maxLength={255}
                                placeholder="Provide details about your issue..."
                                rows={3}
                            />
                        </FormItem>
                    </div>
                    <div className="flex gap-2 pt-2 flex-row-reverse">
                        <CrudButtons
                            mode={mode}
                            recordId={recordData?.tic_id ?? 0}
                            isModal={true}
                            modalId={recordData?.tic_id > 0 ? "edit_ticket" : "add_ticket"}
                            doHideModal={onCancel}
                            cancelLabel="Cancel"
                            submitLabel="Submit Ticket"
                            moduleId={0}
                            cancelIcon=""
                            submitIcon={<Send className="w-4 h-4 mr-2" />}
                            submitClassName={`ticket submit-ticket ${currentConfig.submitButtonClass}`}
                            cancelClassName="ticket cancel-ticket"
                        />
                    </div>
                </div>
            </Form>
        </Card>
    )
};

const mapStateToProps = (state) => ({
    recordData: state.ticket.ticketDetails?.data,
    requesting: state.ticket.ticketDetails?.requesting,
    success: state.ticket.ticketDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getTicketDetails(id)),
    doCreate: (data) => dispatch(doTicketCreate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportTicket);